import React from "react";
import { Sparkles } from "lucide-react";

// Selo no item do pedido (Delivery, Pedidos): diz de onde veio o preço.
export default function SeloOfertaItem({ item }) {
  if (!item?.oferta_id) return null;
  const pct = Number(item.oferta_desconto_pct || 0);
  return (
    <span
      className="inline-flex items-center gap-1 text-[9px] font-black uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-primary/15 text-primary"
      title="Preço sorteado pra este cliente na Campanha Inteligente"
      data-e2e="selo-oferta-item"
    >
      <Sparkles className="w-2.5 h-2.5" />
      Campanha Inteligente{pct > 0 ? ` −${pct}%` : ""}
    </span>
  );
}
